<kpd-confirm-dialog key="delete"></kpd-confirm-dialog>
<app-alert-dialog-large key="importCompleted"></app-alert-dialog-large>
<kpd-data-view
  [tableName]="'users'"
  [dataProvider]="entityFacade"
  [columnsConfig]="columnsConfig"
  [searchConfig]="searchConfig"
  [urlFunction]="urlFunction"
  (linkClicked)="onLinkClicked($event)"
>
  <ng-template kpdTemplate="toolBar" let-loading="loading">
    <kpd-action-bar>
      <div class="actionbar--hide" *ngIf="entityFacade.overviewLoading.length === 0">
        <kpd-action-create
          (action)="onAdd()"
          [title]="'Add user' | translate"
          *kpdPermission="Permissions.UserCreate"
        ></kpd-action-create>
        <app-import *kpdPermission="Permissions.UserImport" (importDone)="onRefresh()"></app-import>
        <span *ngIf="selectedItemIds.length > 0" class="flex-row">
          <kpd-action-consult-overview (action)="onView(selectedItemIds[0])"></kpd-action-consult-overview>
          <kpd-action-edit-toggle
            (action)="onEdit(selectedItemIds[0])"
            *kpdPermission="Permissions.UserUpdate"
            [readMode]="false"
          ></kpd-action-edit-toggle>
          <kpd-action-delete
            (action)="onDelete()"
            *kpdPermission="Permissions.UserDelete"
            [disable]="isSystemUserSelected | async"
          ></kpd-action-delete>
        </span>
        <kpd-action-separator></kpd-action-separator>
      </div>
      <kpd-action
        [icon]="viewType === ViewTypes.Table ? 'view-cards' : 'view-columns'"
        kpdHotkey="mod+m"
        [title]="'Change mode' | translate"
        (action)="onToggleViewType()"
      ></kpd-action>

      <kpd-action
        icon="refresh"
        kpdHotkey="mod+r"
        [title]="'Refresh' | translate"
        [disable]="loading"
        (action)="onRefresh()"
      ></kpd-action>
      <div class="actionbar--hide">
        <kpd-action icon="bars" (action)="onToggleSidepanel()" [title]="'Open sidepanel' | translate"></kpd-action>
      </div>
    </kpd-action-bar>
  </ng-template>

  <ng-template kpdTemplate="cardItem" let-item>
    <div class="card">
      <label class="title" translate>UPN</label>
      <label class="value">{{ item.upn }}</label>
      <label class="title" translate>First name</label>
      <label class="value">{{ item.firstName }}</label>
      <label class="title" translate>Last name</label>
      <label class="value">{{ item.lastName }}</label>
      <label class="title" translate>Name</label>
      <label class="value">{{ item.displayName }}</label>
    </div>
  </ng-template>
</kpd-data-view>
